import { ChevronDown } from "lucide-react";
import { Trans } from "@kit/ui/trans";

export default function FaqItem({
  item,
}: React.PropsWithChildren<{
  item: {
    question: string;
    answer: string;
  };
}>) {
  return (
    <details className="group border-b px-2 py-4 last:border-b-transparent">
      <summary className="flex items-center justify-between hover:cursor-pointer">
        <h3 className="cursor-pointer text-lg">
          <Trans i18nKey={item.question} defaults={item.question} />
        </h3>

        <div>
          <ChevronDown className="h-5 transition duration-300 group-open:-rotate-180" />
        </div>
      </summary>

      <div className="flex flex-col space-y-2 py-1 text-muted-foreground pr-12">
        <Trans i18nKey={item.answer} defaults={item.answer} />
      </div>
    </details>
  );
}
